import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Everyone deserves a front door.",
    body: "Across Pennsylvania, thousands of adults with intellectual and developmental disabilities wait years for a place of their own. TNS Housing Corp exists to answer that question, building housing where people with and without disabilities live side by side, as neighbors.",
  },
  {
    num: "02",
    title: "Built with, not for.",
    body: "Our communities are shaped by the people who will live in them: residents, families, neighbors, and local partners at the table from day one. Inclusion isn't a feature we add. It's the foundation we pour.",
  },
  {
    num: "03",
    title: "Adam's Way is only the beginning.",
    body: "Our mission reaches past a single address: more inclusive housing, in more neighborhoods, for more people, with and without disabilities. Every community we build proves the model and opens the door to the next.",
  },
];

const Manifesto = () => (
  <section id="mission" data-testid="manifesto-section" className="py-28 lg:py-40">
    <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
      <Reveal>
        <p className="overline-label mb-6" data-testid="manifesto-overline">Our Mission</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2
          className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-3xl"
          data-testid="manifesto-heading"
        >
          We build more than housing.{" "}
          <em className="text-primary font-normal">We build belonging.</em>
        </h2>
      </Reveal>

      <div className="mt-20 lg:mt-28 flex flex-col">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.08}>
            <div
              className={`group grid grid-cols-12 gap-6 py-12 lg:py-16 border-t border-foreground/10 transition-colors duration-500 hover:bg-secondary/30 -mx-4 px-4 lg:-mx-8 lg:px-8 rounded-2xl ${
                i === CHAPTERS.length - 1 ? "border-b" : ""
              }`}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="col-span-12 sm:col-span-2">
                <span className="font-serif italic text-2xl text-primary">{c.num}</span>
              </div>
              <div className="col-span-12 sm:col-span-5 lg:col-span-4">
                <h3 className="font-serif font-light text-2xl sm:text-3xl lg:text-4xl leading-tight transition-colors duration-500 group-hover:text-primary">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 sm:col-span-5 lg:col-span-5 lg:col-start-8">
                <p className="text-base lg:text-lg leading-relaxed text-muted-foreground max-w-xl">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
